export default __webpack_public_path__ + "1957268bdc9e79b5335ad565bb3b59a6.png";